'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  a {\n    border-radius: 5px;\n    padding: 5px;\n    font-size: 3rem;\n    text-decoration: none;\n    color: #333;\n    &:hover {\n      color: white;\n      background-color: #777;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  a {\n    border-radius: 5px;\n    padding: 5px;\n    font-size: 3rem;\n    text-decoration: none;\n    color: #333;\n    &:hover {\n      color: white;\n      background-color: #777;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Links = _styledComponents2.default.div(_templateObject);

var SocialMediaLinksContent = function (_Component) {
  _inherits(SocialMediaLinksContent, _Component);

  function SocialMediaLinksContent() {
    _classCallCheck(this, SocialMediaLinksContent);

    return _possibleConstructorReturn(this, (SocialMediaLinksContent.__proto__ || Object.getPrototypeOf(SocialMediaLinksContent)).apply(this, arguments));
  }

  _createClass(SocialMediaLinksContent, [{
    key: 'render',

    /** @function
     * Renders the Social Media Links Content component,
     * displaying icon links to the associated social media
     * sites.  If left blank, the icon is not displayed.
     * @prop {string} facebook - the associated Facebook URL
     * @prop {string} twitter - the associated Twitter URL
     * @prop {string} instagram - the associated Instagram URL
     * @prop {string} googlePlus - the associated Google+ URL
     */
    value: function render() {
      var links = [];
      if (this.props.facebook) {
        links.push(_react2.default.createElement(
          'a',
          { href: this.props.facebook, target: '_blank', key: 'facebook' },
          _react2.default.createElement('i', { className: 'fa fa-facebook' })
        ));
      }
      if (this.props.twitter) {
        links.push(_react2.default.createElement(
          'a',
          { href: this.props.twitter, target: '_blank', key: 'twitter' },
          _react2.default.createElement('i', { className: 'fa fa-twitter' })
        ));
      }
      if (this.props.instagram) {
        links.push(_react2.default.createElement(
          'a',
          { href: this.props.instagram, target: '_blank', key: 'instagram' },
          _react2.default.createElement('i', { className: 'fa fa-instagram' })
        ));
      }
      if (this.props.googlePlus) {
        links.push(_react2.default.createElement(
          'a',
          { href: this.props.googlePlus, target: '_blank', key: 'google' },
          _react2.default.createElement('i', { className: 'fa fa-google-plus' })
        ));
      }
      return _react2.default.createElement(
        Links,
        null,
        links
      );
    }
  }]);

  return SocialMediaLinksContent;
}(_react.Component);

exports.default = SocialMediaLinksContent;


SocialMediaLinksContent.propTypes = {
  facebook: _propTypes2.default.string,
  twitter: _propTypes2.default.string,
  instagram: _propTypes2.default.string,
  googlePlus: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/social-media-links-content.js
// module id = 1038
// module chunks = 0